import Sidebar from "./Layouts/Sidebar/Sidebar";
import Header from "./Layouts/Header/Header";
import Overview from "./Pages/Overview/Overview";
import Newsbar from "./Layouts/Newsbar/Newsbar";
import { Routes, Route } from "react-router";
import Profile from "./Pages/Profile/Profile";
import Board from "./Pages/Board&Managment/Board";
import Chart from "./Pages/Chart/Chart";
import InvestorCalculator from "./Pages/InvestorCalculator/InvestorCalculator";
import MajorShareholders from "./Pages/MajorShareholders/MajorShareholders";
import NegotiatedDeals from "./Pages/Negotiated Deals/NegotiatedDeals";
import FinancialStatments from "./Pages/FinancialStatments/FinancialStatments";
import FinancialReports from "./Pages/FinancialReports/FinancialReports";
import Annual from "./Components/FinancialReportsComps/Annual/Annual";
import Quarter from "./Components/FinancialReportsComps/Quarter/Quarter";
import BoardReport from "./Components/FinancialReportsComps/BoardReport/BoardReport";
import MarketData from "./Components/OverviewComps/MarketDate/MarketData";
import FinancialRatios from "./Components/OverviewComps/FinancialRatios/FinancialRatios";
import CorporateActions from "./Components/OverviewComps/CorporateActions/CorporateActions";
import { CorporateActions as CorporateActionsPage } from "./Pages/CorporateActions/CorporateActions";
import Disclosers from "./Components/OverviewComps/Disclosers/Disclosers";
import CapitalChanges from "./Components/CorporateActionsComps/CapitalChanges/CapitalChanges";
import HistoricalDividends from "./Components/CorporateActionsComps/HistoricalDividends/HistoricalDividends";
import RecentChanges from "./Components/GlobalComps/RecentChanges/RecentChanges";
import RecentDividends from "./Components/GlobalComps/RecentDividends/RecentDividends";
import BasicInfoSec from "./Components/ProfileComps/BasicInfoSec/BasicInfoSec";
import FinancialHighlightsSec from "./Components/ProfileComps/FinancialHighlightsSec/FinancialHighlightsSec";
import TradingDataSec from "./Components/ProfileComps/TradingDataSec/TradingDataSec";
import StockInfoSec from "./Components/ProfileComps/StockInfoSec/StockInfoSec";
import MajorShareholdersSec from "./Components/ProfileComps/MajorShareholdersSec/MajorShareholdersSec";
import MilestonesSec from "./Components/ProfileComps/MilestonesSec/MilestonesSec";
import Projects from "./Pages/Projects/Projects";
import AnalystCoverage from "./Pages/AnalystCoverage/AnalystCoverage";
import SubscriptionCenter from "./Pages/SubscriptionCenter/SubscriptionCenter";
import FinancialRatiosPage from "./Pages/FinancialRatiosPage/FinancialRatiosPage";
import InvestorPresentations from "./Pages/InvestorPresentations/InvestorPresentations";
import BusinessSegments from "./Pages/BusinessSegments/BusinessSegments";
import DisclosuresPage from "./Pages/DisclosuresPage/DisclosuresPage";
import DisclosuresMainComp from "./Components/DisclosuresComps/DisclosuresMainComp/DisclosuresMainComp";
import News from "./Components/DisclosuresComps/News/News";
import Events from "./Components/DisclosuresComps/Events/Events";
import AnalystEstimates from "./Components/DisclosuresComps/AnalystEstimates/AnalystEstimates";
import YearsChart from "./Components/ChartPageComps/YearsChart/YearsChart";
import HistoricalTradingData from "./Components/ChartPageComps/FinancialHighlights/HistoricalTradingData";
import ForeginOwnership from "./Components/MajorShareholderComps/ForeignOwnership/ForeginOwnership";
import HistoricalChanges from "./Components/MajorShareholderComps/HistoricalChanges/HistoricalChanges";
import BoardMainSec from "./Components/BoardComps/BoardMainSec/BoardMainSec";
import SalariesAndBonuses from "./Components/BoardComps/Salaries&Bonuses/Salaries&Bonuses";
import CompnayOverview from "./Components/OverviewComps/CompanyOverview/CompnayOverview";
import { token } from "./Services/services";
import { useEffect, useRef, useState } from "react";
import AnalystCoverageMainComp from "./Components/AnalystCoverageComps/AnalystCoverageMainComp/AnalystCoverageMainComp";
import Opinions from "./Components/AnalystCoverageComps/Opinions/Opinions";
import { AnimatePresence } from "framer-motion";

function App() {
  const [auth, setAuth] = useState(false);
  useEffect(() => {
    token().then(() => setAuth(true));
  }, []);

  // ***************** Iframe - Handling **************************
  const [pageheight, setHeight] = useState();
  const elemRef = useRef(null);

  useEffect(() => {
    if (!elemRef?.current) return;

    const observer = new ResizeObserver(() =>
      setHeight(elemRef?.current?.offsetHeight)
    );
    observer.observe(elemRef?.current);

    return () => observer.disconnect();
  }, [elemRef]);

  useEffect(() => {
    window?.parent &&
      window?.parent?.postMessage(
        { type: "contentHeight", height: pageheight },
        "http://127.0.0.1:5501/" 
      );
  }, [pageheight]);
  // *******************************************************************

  console.log(window.parent.origin);

  return (
    <div ref={elemRef}>
      {!auth ? (
        <div className="full-app-loader">
          <div className="three-body">
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
          </div>
        </div>
      ) : (
        <div className="App">
          <Header />
          <div className="container-lg">
            <div className="row">
              <div className="col-lg-3 col-md-12 sidebar-container p-0">
                <Sidebar />
              </div>
              <div className="col-lg-9 col-md-12 col-sm-12 col-12 px-3">
                <div className="min-height mx-3 pb-5">
                  <AnimatePresence>
                    <Routes>
                      {["/", "/ir", "/ir/overview"].map((path, idx) => (
                        <Route key={idx} path={path} element={<Overview />}>
                          <Route index element={<CompnayOverview />} />
                        </Route>
                      ))}

                      <Route path="/ir/overview" element={<Overview />}>
                        <Route
                          path="/ir/overview/company-overview"
                          element={<CompnayOverview />}
                        />
                        <Route
                          path="/ir/overview/market-data"
                          element={<MarketData />}
                        />

                        <Route
                          path="/ir/overview/financial-ratios"
                          element={<FinancialRatios />}
                        />

                        <Route
                          path="/ir/overview/corporate-actions"
                          element={<CorporateActions />}
                        />

                        <Route
                          path="/ir/overview/disclosers"
                          element={<Disclosers />}
                        />
                      </Route>

                      <Route path="/ir/profile" element={<Profile />}>
                        <Route index element={<BasicInfoSec />} />
                        <Route
                          path="/ir/profile/basic-info"
                          element={<BasicInfoSec />}
                        />
                        <Route
                          path="/ir/profile/financial-highlights"
                          element={<FinancialHighlightsSec />}
                        />
                        <Route
                          path="/ir/profile/trading-data"
                          element={<TradingDataSec />}
                        />
                        <Route
                          path="/ir/profile/stock-info"
                          element={<StockInfoSec />}
                        />
                        <Route
                          path="/ir/profile/subdiaries"
                          element={<MajorShareholdersSec />}
                        />
                        <Route
                          path="/ir/profile/subdairies"
                          element={<MajorShareholdersSec />}
                        />
                        <Route
                          path="/ir/profile/milestones"
                          element={<MilestonesSec />}
                        />
                      </Route>

                      <Route path="/ir/board&managment" element={<Board />}>
                        <Route index element={<BoardMainSec />} />
                        <Route
                          path="/ir/board&managment/board"
                          element={<BoardMainSec />}
                        />
                        <Route
                          path="/ir/board&managment/salaries&bonuses"
                          element={<SalariesAndBonuses />}
                        />
                      </Route>
                      <Route path="/ir/chart" element={<Chart />}>
                        <Route index element={<YearsChart />} />
                        <Route
                          path="/ir/chart/stock-chart"
                          element={<YearsChart />}
                        />
                        <Route
                          path="/ir/chart/historical-trading-data"
                          element={<HistoricalTradingData />}
                        />
                      </Route>
                      <Route
                        path="/ir/majorshareholders"
                        element={<MajorShareholders />}
                      >
                        <Route index element={<ForeginOwnership />} />
                        <Route
                          path="/ir/majorshareholders/foreignownership"
                          element={<ForeginOwnership />}
                        />
                        <Route
                          path="/ir/majorshareholders/historical-changes"
                          element={<HistoricalChanges />}
                        />
                      </Route>
                      <Route
                        path="/ir/negotiated-deals"
                        element={<NegotiatedDeals />}
                      />
                      <Route
                        path="/ir/financial-statments"
                        element={<FinancialStatments />}
                      />
                      <Route
                        path="/ir/financial-ratios-fullpage"
                        element={<FinancialRatiosPage />}
                      />
                      <Route
                        path="/ir/financial-reports"
                        element={<FinancialReports />}
                      >
                        <Route index element={<Annual />} />
                        <Route
                          path="/ir/financial-reports/annual"
                          element={<Annual />}
                        />
                        <Route
                          path="/ir/financial-reports/quarter"
                          element={<Quarter />}
                        />
                        <Route
                          path="/ir/financial-reports/board-report"
                          element={<BoardReport />}
                        />
                      </Route>

                      <Route
                        path="/ir/investor-presentations"
                        element={<InvestorPresentations />}
                      />

                      <Route
                        path="/ir/business-segments"
                        element={<BusinessSegments />}
                      />

                      <Route
                        path="/ir/corporate-actions-fullpage"
                        element={<CorporateActionsPage />}
                      >
                        <Route index element={<CapitalChanges />} />
                        <Route
                          path="/ir/corporate-actions-fullpage/capital-changes"
                          element={<CapitalChanges />}
                        />

                        <Route
                          path="/ir/corporate-actions-fullpage/historical-dividends"
                          element={<HistoricalDividends />}
                        />
                        <Route
                          path="/ir/corporate-actions-fullpage/recent-changes"
                          element={<RecentChanges />}
                        />
                        <Route
                          path="/ir/corporate-actions-fullpage/recent-dividends"
                          element={<RecentDividends />}
                        />
                      </Route>

                      <Route path="/ir/projects" element={<Projects />} />
                      <Route
                        path="/ir/analyst-coverage"
                        element={<AnalystCoverage />}
                      >
                        <Route index element={<AnalystCoverageMainComp />} />
                        <Route
                          path="/ir/analyst-coverage/analyst-estimates"
                          element={<AnalystCoverageMainComp />}
                        />
                        <Route
                          path="/ir/analyst-coverage/opinions"
                          element={<Opinions />}
                        />
                      </Route>
                      <Route
                        path="/ir/subscription-center"
                        element={<SubscriptionCenter />}
                      />

                      <Route
                        path="/ir/investor-calculator"
                        element={<InvestorCalculator />}
                      />

                      <Route
                        path="/ir/disclosures"
                        element={<DisclosuresPage />}
                      >
                        <Route index element={<DisclosuresMainComp />} />
                        <Route
                          path="/ir/disclosures/main-sec"
                          element={<DisclosuresMainComp />}
                        />
                        <Route path="/ir/disclosures/news" element={<News />} />
                        <Route
                          path="/ir/disclosures/events"
                          element={<Events />}
                        />
                        <Route
                          path="/ir/disclosures/analyst-estimates"
                          element={<AnalystEstimates />}
                        />
                      </Route>
                    </Routes>
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </div>
          <Newsbar />
        </div>
      )}
    </div>
  );
}

export default App;
